import { apiRequest } from "./common";

const createCalenderEvent = async (data) => {
    const response = await apiRequest('post', '/calendar-event', data);
    return response.data;
};

const updateCalenderEvent = async (id, data) => {
    const response = await apiRequest('put', `/calendar-event/${id}`, data);
    return response.data;
};

const deleteCalendarEvent = async (id) => {
    const response = await apiRequest('delete', `/calendar-event/${id}`);
    return response.data;
};

const getCalendarEvent = async (userId, type) => {
    const response = await apiRequest('get', `/calendar-event/by-user/${userId}/upcoming?days=7${type && `&test_type=${type}`}`);
    return response.data;
};

const getAllCalendarEvent = async (userId, month, year, startdate, enddate, studentId) => {
    const params = new URLSearchParams();
    params.append('user_id', userId);
    if (year !== null) params.append('year', year);
    if (month !== null) params.append('month', month);
    if (startdate !== null) params.append('start_date', new Date(startdate).toISOString());
    if (enddate !== null) params.append('end_date', new Date(enddate).toISOString());
    params.append('student_id', studentId)

    const queryString = params.toString();
    const response = await apiRequest('get', `/calendar-event?${queryString}`);
    return response.data;
}

const uploadEvent = async (data) => {
  const response = await apiRequest('post','/calendar-event/import',data);
  return response.data;
}

const getAllSession = async (month, year, startdate, enddate, service, mentorProfileId) => {
    const params = new URLSearchParams();
    if (year !== null) params.append('year', year);
    if (month !== null) params.append('month', month);
    if (startdate !== null) params.append('start_date', new Date(startdate).toISOString());
    if (enddate !== null) params.append('end_date', new Date(enddate).toISOString());
    if(service !== null) params.append('service_name', service);
    params.append('mentor_profile_id', mentorProfileId);

    const queryString = params.toString();
    const response = await apiRequest('get', `/session/by-mentor?${queryString}`);
    return response.data;
}

export {
    createCalenderEvent,
    updateCalenderEvent,
    getCalendarEvent,
    deleteCalendarEvent,
    getAllCalendarEvent,
    uploadEvent,
    getAllSession
}